import { connect } from "react-redux";
import React, { Component } from "react";
import Breadcrumb from "../../common/breadcrumb";
import {
  getValueFromLanguageObject,
  loadUserDetailsFromLocalStorage,
} from "../../../store";
import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
} from "../../../utils/utils";
import { Helmet } from "react-helmet";
import { getCall } from "../../../api/post";
import { getAboutUsUrl } from "../../../services";
import createDOMPurify from "dompurify";
// guard for SSR
const DOMPurify =
  typeof window !== "undefined" && createDOMPurify
    ? createDOMPurify(window)
    : { sanitize: (html) => html || "" };

class AboutUs extends Component {
  state = {
    AppTitle: "",
    aboutUsData: "",
    loading: true,
    error: null,
  };

  componentDidMount() {
    // Authentication/redirection moved to central route guard (PrivateRoute).
    this.fetchAboutUs();
  }

  fetchAboutUs = async () => {
    try {
      const aboutUsUrl = getAboutUsUrl();
      const data = await getCall(aboutUsUrl, []);
      if (data.error) {
        throw new Error(data.error.message || "Failed to fetch About Us");
      }
      this.setState({
        aboutUsData: data.text || "",
        loading: false,
      });
    } catch (error) {
      this.setState({
        error: error.message,
        loading: false,
      });
    }
  };

  render() {
    const { aboutUsData, loading, error } = this.state;

    return (
      <div>
        {/*SEO Support*/}
        <Helmet>
          <title>
            {this.state.AppTitle} |{" "}
            {getValueFromLanguageObject("str_about_us")
              ? getValueFromLanguageObject("str_about_us")
              : "About Us"}{" "}
          </title>
          <meta
            name="description"
            content="About rezREWARDS - Exclusive loyalty program of RezLive.com for travel partners. Earn reward points for every successful transaction and redeem for products & services."
          />
        </Helmet>
        {/*SEO Support End */}
        <Breadcrumb
          title={
            getValueFromLanguageObject("str_about_us")
              ? getValueFromLanguageObject("str_about_us")
              : "About Us"
          }
        />

        <section className="about-section section-b-space">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="about-content">
                  <div className="row">
                    {/* Left Content - API Dynamic */}
                    <div className="col-md-8">
                      <h3 style={{
                        fontWeight: 'bold',
                        marginBottom: '40px',
                        color: '#333'
                      }}>
                        About rezREWARDS:
                      </h3>
                      {loading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                          <p>Loading About Us...</p>
                        </div>
                      ) : error ? (
                        <div style={{
                          backgroundColor: '#f8d7da',
                          border: '1px solid #f5c6cb',
                          color: '#721c24',
                          padding: '15px',
                          borderRadius: '5px',
                          marginBottom: '20px'
                        }}>
                          <p>Error loading About Us: {error}</p>
                        </div>
                      ) : (
                        <>
                          {/* restore bullets and normal wrapping for injected HTML */}
                          <style>{`
                            .about-content ul, .about-content ol {
                              list-style-type: disc !important;
                              list-style-position: outside !important;
                              margin: 0.5rem 0 0.5rem 1.25rem !important;
                              padding-left: 1.25rem !important;
                            }
                            .about-content li {
                              display: list-item !important;
                              margin-bottom: 0.5rem !important;
                            }
                            .about-content img { max-width: 100%; height: auto; display: block; margin: 0.5rem 0; }
                          `}</style>
                          <div
                            style={{ fontSize: "14px", lineHeight: "1.6", color: "#333" }}
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(aboutUsData || ""),
                            }}
                          />
                        </>
                      )}
                    </div>
                    {/* Right Content - How it Works (static, not removed) */}
                    <div className="col-md-4">
                      <div style={{
                        backgroundColor: '#f39e1d',
                        padding: '25px',
                        borderRadius: '10px',
                        marginBottom: '30px',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                      }}>
                        <h3 style={{
                          fontWeight: 'bold',
                          margin: '0',
                          color: '#333',
                          textAlign: 'center'
                        }}>
                          How it Works
                        </h3>
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        {/* Step 01 */}
                        <div style={{
                          backgroundColor: '#6f42c1',
                          padding: '20px',
                          borderRadius: '10px',
                          position: 'relative',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px'
                          }}>
                            <div style={{
                              backgroundColor: '#f39e1d',
                              color: '#333',
                              width: '45px',
                              height: '45px',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: 'bold',
                              flexShrink: 0,
                              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                            }}>
                              01
                            </div>
                            <p style={{
                              color: 'white',
                              margin: '0',
                              lineHeight: '1.5'
                            }}>
                              You must be an Active Agent on RezLive.com
                            </p>
                          </div>
                        </div>
                        <div style={{ textAlign: 'center', color: '#6f42c1', margin: '5px 0' }}>▼</div>
                        {/* Step 02 */}
                        <div style={{
                          backgroundColor: '#6f42c1',
                          padding: '20px',
                          borderRadius: '10px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px'
                          }}>
                            <div style={{
                              backgroundColor: '#f39e1d',
                              color: '#333',
                              width: '45px',
                              height: '45px',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: 'bold',
                              flexShrink: 0,
                              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                            }}>
                              02
                            </div>
                            <p style={{
                              color: 'white',
                              margin: '0',
                              lineHeight: '1.5'
                            }}>
                              Login to rezREWARDS with your username and password
                            </p>
                          </div>
                        </div>
                        <div style={{ textAlign: 'center', color: '#6f42c1', margin: '5px 0' }}>▼</div>
                        {/* Step 03 */}
                        <div style={{
                          backgroundColor: '#6f42c1',
                          padding: '20px',
                          borderRadius: '10px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px'
                          }}>
                            <div style={{
                              backgroundColor: '#f39e1d',
                              color: '#333',
                              width: '45px',
                              height: '45px',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: 'bold',
                              flexShrink: 0,
                              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                            }}>
                              03
                            </div>
                            <p style={{
                              color: 'white',
                              margin: '0',
                              lineHeight: '1.5'
                            }}>
                              Ensure sufficient rezREWARDS points in your account
                            </p>
                          </div>
                        </div>
                        <div style={{ textAlign: 'center', color: '#6f42c1', margin: '5px 0' }}>▼</div>
                        {/* Step 04 */}
                        <div style={{
                          backgroundColor: '#6f42c1',
                          padding: '20px',
                          borderRadius: '10px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px'
                          }}>
                            <div style={{
                              backgroundColor: '#f39e1d',
                              color: '#333',
                              width: '45px',
                              height: '45px',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: 'bold',
                              flexShrink: 0,
                              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                            }}>
                              04
                            </div>
                            <p style={{
                              color: 'white',
                              margin: '0',
                              lineHeight: '1.5'
                            }}>
                              Select the item to redeem and click "Add to Cart"
                            </p>
                          </div>
                        </div>
                        <div style={{ textAlign: 'center', color: '#6f42c1', margin: '5px 0' }}>▼</div>
                        {/* Step 05 */}
                        <div style={{
                          backgroundColor: '#6f42c1',
                          padding: '20px',
                          borderRadius: '10px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px'
                          }}>
                            <div style={{
                              backgroundColor: '#f39e1d',
                              color: '#333',
                              width: '45px',
                              height: '45px',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: 'bold',
                              flexShrink: 0,
                              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                            }}>
                              05
                            </div>
                            <p style={{
                              color: 'white',
                              margin: '0',
                              lineHeight: '1.5'
                            }}>
                              After selecting the product(s), click "Order Now"
                            </p>
                          </div>
                        </div>
                        <div style={{ textAlign: 'center', color: '#6f42c1', margin: '5px 0' }}>▼</div>
                        {/* Step 06 */}
                        <div style={{
                          backgroundColor: '#6f42c1',
                          padding: '20px',
                          borderRadius: '10px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px'
                          }}>
                            <div style={{
                              backgroundColor: '#f39e1d',
                              color: '#333',
                              width: '45px',
                              height: '45px',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: 'bold',
                              flexShrink: 0,
                              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                            }}>
                              06
                            </div>
                            <p style={{
                              color: 'white',
                              margin: '0',
                              lineHeight: '1.5'
                            }}>
                              You will get the auto email once your order is shipped
                            </p>
                          </div>
                        </div>
                        <div style={{ textAlign: 'center', color: '#6f42c1', margin: '5px 0' }}>▼</div>
                        {/* Step 07 */}
                        <div style={{
                          backgroundColor: '#6f42c1',
                          padding: '20px',
                          borderRadius: '10px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px'
                          }}>
                            <div style={{
                              backgroundColor: '#f39e1d',
                              color: '#333',
                              width: '45px',
                              height: '45px',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: 'bold',
                              flexShrink: 0,
                              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                            }}>
                              07
                            </div>
                            <p style={{
                              color: 'white',
                              margin: '0',
                              lineHeight: '1.5'
                            }}>
                              Points will be deducted from your account immediately and the order will be processed
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* End Right Content */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(AboutUs);
